import scrollMonitor from 'scrollmonitor';
import parallax from 'scrollmonitor-parallax';

const element = document.querySelector('.js-intro');
const target = document.querySelector('.js-intro__target');
var elementWatcher;
var parallaxRoot;

const breakpoint = 768;
const desktopSpeed = -0.65;
const mobileSpeed = -0.25;
const speed = (window.screen.width > breakpoint) ? desktopSpeed : mobileSpeed;

if (element) {
  elementWatcher = scrollMonitor.create(element);

  elementWatcher.enterViewport(function() {
    target.classList.remove('is-hidden');
  });
  elementWatcher.exitViewport(function() {
    target.classList.add('is-hidden');
  });

  parallaxRoot = parallax.create(element);
  parallaxRoot.add(target, speed);
}
